import { ROUTES } from '~app/router/routes';

import { ReactComponent as IconBanknote } from '~assets/icons/icon-banknote.svg';
import { ReactComponent as IconBell } from '~assets/icons/icon-bell.svg';
import { ReactComponent as IconBill } from '~assets/icons/icon-bill.svg';
import { ReactComponent as IconBuilding1 } from '~assets/icons/icon-building-1.svg';
import { ReactComponent as IconContract2 } from '~assets/icons/icon-contract-2.svg';
import { ReactComponent as IconDashboard } from '~assets/icons/icon-dashboard.svg';
import { ReactComponent as IconMessageSquareText } from '~assets/icons/icon-message-square-text.svg';
import { ReactComponent as IconUsers } from '~assets/icons/icon-users.svg';

export type SidebarRouteType = {
  label: string;
  route?: string;
  icon?: React.FC | null;
  needActiveBrand?: boolean;
  heading?: boolean;
  access: string | string[] | null;
  subRoutes: SidebarRouteType[] | null;
};

export const lessorSidebarLinks: SidebarRouteType[] = [
  {
    label: 'Головна',
    route: '/',
    icon: IconDashboard,
    heading: false,
    subRoutes: null,
    access: null,
  },
  {
    label: 'Управління',
    icon: null,
    access: null,
    heading: true,
    subRoutes: [
      {
        label: 'Нерухомість',
        route: ROUTES.PROPERTIES,
        icon: IconBuilding1,
        access: null,
        subRoutes: null,
      },
      {
        label: 'Орендарі',
        route: ROUTES.TENANTS,
        icon: IconUsers,
        access: null,
        subRoutes: null,
      },
      {
        label: 'Нагадування',
        route: ROUTES.REMINDERS,
        icon: IconBell,
        access: null,
        subRoutes: null,
      },
    ],
  },
  {
    label: 'Оренда',
    icon: null,
    access: null,
    heading: true,
    subRoutes: [
      {
        label: 'Договори оренди',
        route: ROUTES.LEASES,
        icon: IconContract2,
        access: null,
        subRoutes: null,
      },
    ],
  },
  {
    label: 'Фінанси',
    icon: null,
    access: null,
    heading: true,
    subRoutes: [
      {
        label: 'Рахунки',
        route: ROUTES.INVOICES,
        icon: IconBill,
        access: null,
        subRoutes: null,
      },
      {
        label: 'Платежі',
        route: ROUTES.PAYMENTS_RECORDS,
        icon: IconBanknote,
        access: null,
        subRoutes: null,
      },
    ],
  },
  {
    label: 'Допомога',
    icon: null,
    access: null,
    heading: true,
    subRoutes: [
      {
        label: 'Служба турботи',
        route: ROUTES.SUPPORT,
        icon: IconMessageSquareText,
        access: null,
        subRoutes: null,
      },
    ],
  },
  // {
  //   label: 'Статистика',
  //   route: '/statistics',
  //   icon: Chart,
  //   access: null,
  //   subRoutes: null,
  // },
];
